import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import localizations from './localizations.json';

// Правильная структура ресурсов для i18next
const resources = {
  ru: {
    translation: localizations.ru
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ru',
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false, // не нужно экранировать для React
    },
  });

console.log('Инициализация i18n завершена. Доступные языки:', Object.keys(resources));
console.log('Загружены следующие ключи:', Object.keys(resources.ru.translation));

export default i18n; 